import { collection, doc, getDocs } from 'firebase/firestore';
import { auth } from '../firebase/auth';
import { db } from '../firebase/firestore';
import { createModel } from './model';

export const schema = {
  name: 'organization',
  collectionName: 'orgs',
  properties: {
    createdAt: {
      type: 'timestamp',
      label: 'Created At',
      required: true,
    },
    updatedAt: {
      type: 'timestamp',
      label: 'Updated At',
      required: true,
    },
    createdBy: {
      type: 'string',
      label: 'Created By',
      required: true,
      inputType: 'user',
    },
    name: {
      type: 'string',
      label: 'Name',
      required: true,
    },
  },
  inputProperties: ['name'],
  serialize: (doc) => ({
    name: doc.name,
    createdBy: auth.currentUser?.uid,
  }),
  async parse(doc) {
    // console.log('Parsing organization document:', doc);
    return doc;
  },
  getOptionLabel: org => org.name,
  getTitle: org => org.name,
};

const model = createModel(schema);

model.getMembers = async function(orgId) {
  const membersCollection = collection(db, 'orgs', orgId, 'members');
  const membersSnapshot = await getDocs(membersCollection);

  return membersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export default model;
